<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>购物车管理</span>
      </div>
      
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="用户手机号">
          <el-input v-model="queryParams.userPhone" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="cartList">
        <el-table-column label="购物车ID" align="center" prop="id" width="100" />
        <el-table-column label="用户信息" align="center" prop="userName" width="120" />
        <el-table-column label="商品名称" align="center" prop="goodsName" show-overflow-tooltip />
        <el-table-column label="规格信息" align="center" prop="specInfo" width="150" />
        <el-table-column label="数量" align="center" prop="quantity" width="100" />
        <el-table-column label="单价" align="center" prop="price" width="100" />
        <el-table-column label="小计" align="center" prop="totalPrice" width="100" />
        <el-table-column label="添加时间" align="center" prop="createTime" width="180" />
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CartList',
  data() {
    return {
      loading: true,
      total: 0,
      cartList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userPhone: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      // TODO: 调用API获取购物车列表
      setTimeout(() => {
        this.cartList = []
        this.total = 0
        this.loading = false
      }, 500)
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleDelete(row) {
      this.$confirm('是否确认删除该购物车项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('删除成功')
        this.getList()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
